var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestTubes3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58582 1H4L3 1.95455L4 2.90909V18.1818C4 20.2904 5.79068 21.9998 7.99966 22C7.53855 21.3861 7.21545 20.6626 7.07644 19.8756C6.43674 19.5571 6 18.9182 6 18.1818V2.90909H6.49491L5.58582 2L6.58582 1ZM8.1506 20.0909C8.36236 20.8396 8.78666 21.4991 9.3542 22H10V20.0909H8.1506ZM10 1H8.00003L7.00003 2L7.90912 2.90909H10V1Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2L20 1H8L7 2L8 3V19C8 21.2091 9.79086 23 12 23H16C18.2091 23 20 21.2091 20 19V3L21 2ZM18 3H10V19C10 20.1046 10.8954 21 12 21H16C17.1046 21 18 20.1046 18 19V3Z",
    fill: "#3360AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10.5002H17V19.2694C17 19.673 16.5523 20.0002 16 20.0002H12C11.4477 20.0002 11 19.673 11 19.2694V10.5002Z",
    fill: "#208C72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTubes3);
export default __webpack_public_path__ + "static/media/test-tubes-3.ae6e4a1783e0aa83ca44772b7ccaac13.svg";
export { ForwardRef as ReactComponent };